import React from 'react';
import { FaChevronDown, FaInfoCircle } from 'react-icons/fa';
import { useLocalStorage } from '../common/localStorage';

/*
 * Collapsible guidance panel. Tips are worth reading once and then mostly in
 * the way, so the open/closed choice is remembered per card — keyed by id, so
 * dismissing the upload tips does not also collapse the search tips.
 *
 * Pass `items` for a bullet list, or `children` for arbitrary content.
 */
const InfoCard = ({
  id,
  title,
  items,
  children,
  defaultOpen = true,
  className = '',
}) => {
  const [open, setOpen] = useLocalStorage(`infoCard:${id}`, defaultOpen);

  return (
    <div className={`rounded-lg border border-gray-200 bg-gray-50 ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={`infocard-${id}`}
        className="flex w-full items-center gap-2 px-4 py-3 text-left"
      >
        <FaInfoCircle className="flex-shrink-0 text-gray-400" />
        <span className="flex-1 text-sm font-semibold text-gray-700">{title}</span>
        <FaChevronDown
          className={`flex-shrink-0 text-xs text-gray-400 transition-transform ${
            open ? 'rotate-180' : ''
          }`}
          aria-hidden="true"
        />
      </button>

      {open && (
        <div id={`infocard-${id}`} className="px-4 pb-3.5 pl-10">
          {items ? (
            <ul className="space-y-1.5 text-sm text-gray-600">
              {items.map((item) => (
                <li key={typeof item === 'string' ? item : item.key} className="flex gap-2">
                  <span
                    className="mt-1.5 h-1 w-1 flex-shrink-0 rounded-full bg-gray-400"
                    aria-hidden="true"
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-sm text-gray-600">{children}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default InfoCard;
